// extracted by mini-css-extract-plugin
export default {"title":"style_title__0xbRp","host":"style_host__e-Hjm","submit":"style_submit__NfMal"};